import React, { useState } from 'react'
import { Container, Paper, TextField, Avatar, Typography, InputAdornment, IconButton, Grid, Button, CircularProgress } from "@material-ui/core";
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { useDispatch, useSelector } from "react-redux";
import { signup, signin } from "./../redux/actions/user";
import { useHistory, Redirect } from "react-router-dom";

import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const Auth = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const reqProfile = useSelector(state => state.user);
    const user = JSON.parse(localStorage.getItem("profile"));

    const [signUp, setSignUp] = useState(false);
    const [showPass, setShowPass] = useState(false);
    const [dataForm, setDataForm] = useState({
        firstName: "", lastName: "", email: "", password: "", confirmPassword: ""
    });

    const handleChange = (e) => setDataForm({ ...dataForm, [e.target.name]: e.target.value });
    const handleShowPassword = () => setShowPass(!showPass);
    const handleChangeMode = () => setSignUp(!signUp);
    const clear = () => setDataForm({ firstName: "", lastName: "", email: "", password: "", confirmPassword: "" });

    const handleSubmit = () => {
        if (signUp) {
            dispatch(signup(dataForm, history));
        }
        else {
            dispatch(signin(dataForm, history));
            clear();
        }
    }

    if (user) return <Redirect to="/" />

    return (
        <Container maxWidth="md">
            <Grid container style={{ margin: "7% 0" }}>
                <Grid item xs={12} sm={6} style={{ backgroundColor: "#3F51B5", padding: "5%", borderRadius: "5px" }}>
                    <Typography variant="h3" style={{ fontWeight: "bolder", color: "white" }}>
                        {signUp ? "Sign up" : "Login"}
                    </Typography>
                    <br></br>
                    <Typography variant="body1" style={{ color: "white" }}>
                        {signUp ?
                            "Register and create an account on K Net. Create your posts anytime and anywhere." :
                            "Log in and start creating your own posts."
                        }
                    </Typography>
                    <Button onClick={handleChangeMode} style={{ color: "white" }}>
                        {signUp ? 'Already have an account ? Log in' : "Don't have an account ? Sign Up"}
                    </Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Paper style={{ padding: "5%" }}>

                        {signUp && (
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <TextField required name="firstName" variant="outlined" label="First Name" fullWidth onChange={handleChange}
                                        style={{ marginBottom: "12px" }} value={dataForm.firstName} />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField required name="lastName" variant="outlined" label="Last Name" fullWidth onChange={handleChange}
                                        style={{ marginBottom: "12px" }} value={dataForm.lastName} />
                                </Grid>
                            </Grid>
                        )}

                        <TextField required name="email" variant="outlined" label="Email" fullWidth onChange={handleChange}
                            style={{ marginBottom: "12px" }} value={dataForm.email} />

                        <TextField required type={showPass ? "text" : "password"} name="password" variant="outlined" label="Password"
                            fullWidth onChange={handleChange} style={{ marginBottom: "12px" }} value={dataForm.password}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={handleShowPassword}>
                                            {!showPass ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />

                        {signUp && (
                            <TextField required name="confirmPassword" variant="outlined" label="Confirm Password" fullWidth onChange={handleChange}
                                style={{ marginBottom: "10px" }} type="password" value={dataForm.confirmPassword} />
                        )}

                        <div style={{ textAlign: "center", margin: "5px 0" }}>
                            {reqProfile.loading && <CircularProgress />}
                        </div>

                        {reqProfile.error && (
                            <small style={{ color: "red" }}>{reqProfile.error}</small>
                        )}

                        <Button fullWidth color="primary" variant="contained" onClick={handleSubmit}>
                            {signUp ? "Sign Up" : "Login"}
                        </Button>
                    </Paper>
                </Grid>
            </Grid>
        </Container>
    )
}

export default Auth;